<template>
  <div>
    <div class="title">什么时候可以下单？</div>
    <div class="content-info">
      <p class="txt1">下单时间为：上午8:00-晚上23:00。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
